var map = {
	"./abra.png": 65420,
	"./acs-mini.png": 37629,
	"./acs.png": 14616,
	"./ai-addon-chatbot.jpg": 90109,
	"./ai-addon-mailer.jpg": 70001,
	"./ai-addon-related-products.jpg": 56129,
	"./ai-addon-search.jpg": 34995,
	"./ai.png": 31801,
	"./allegro-mini.png": 19045,
	"./allegro.png": 51363,
	"./alza.png": 49404,
	"./amazon.png": 68068,
	"./api.png": 27754,
	"./besteron.png": 87975,
	"./billdu.png": 23966,
	"./billingo.png": 78681,
	"./biznisweb.png": 94587,
	"./blank.png": 10290,
	"./boxnow-mini.png": 18333,
	"./boxnow.png": 87021,
	"./boxpi-mini.png": 35114,
	"./boxpi.png": 39641,
	"./brani.png": 14505,
	"./cargus-mini.png": 15177,
	"./cargus.png": 84349,
	"./case-1.jpg": 13609,
	"./case-2.jpg": 44160,
	"./case-3.jpg": 57258,
	"./case-4.jpg": 93579,
	"./case-5.jpg": 9940,
	"./case-6.jpg": 38992,
	"./case-7.jpg": 97454,
	"./case-8.jpg": 75822,
	"./citfin.png": 16720,
	"./clients-1.png": 24319,
	"./clients-10.png": 56898,
	"./clients-11.png": 51428,
	"./clients-12.png": 96527,
	"./clients-2.png": 90098,
	"./clients-3.png": 10349,
	"./clients-4.png": 49735,
	"./clients-5.png": 1931,
	"./clients-6.png": 13374,
	"./clients-7.png": 64941,
	"./clients-8.png": 23988,
	"./clients-9.png": 89764,
	"./creativesites.png": 86136,
	"./cscart.png": 77222,
	"./csp.png": 67923,
	"./dashboard-invoices.png": 92988,
	"./dashboard-order.png": 54250,
	"./dashboard-orders.png": 84539,
	"./dashboard-packages.png": 26758,
	"./dashboard-setup.png": 91248,
	"./depo-mini.png": 3608,
	"./depo.png": 11895,
	"./dhl-mini.png": 63669,
	"./dhl.png": 65145,
	"./dpd-mini.png": 8361,
	"./dpd.png": 72099,
	"./dpdcz-mini.png": 78403,
	"./dpdcz.png": 31994,
	"./dpdhu-mini.png": 73598,
	"./dpdhu.png": 51813,
	"./dpdpl-mini.png": 53910,
	"./dpdpl.png": 86215,
	"./dpdro-mini.png": 72944,
	"./dpdro.png": 67056,
	"./draw-arrow.svg": 52,
	"./ebay.png": 42942,
	"./ecwid.png": 20271,
	"./ekokrajina.png": 77378,
	"./eli.png": 41873,
	"./emag-mini.png": 47824,
	"./emag.png": 47823,
	"./email.png": 65595,
	"./employee.png": 29801,
	"./eshoprychlo.png": 85353,
	"./etsy.png": 46949,
	"./excel.png": 97465,
	"./expressone-mini.png": 73325,
	"./expressone.png": 79413,
	"./ezdrav.png": 42871,
	"./facebook.png": 84141,
	"./fakturoid.png": 87367,
	"./fakturownia.png": 1263,
	"./fakturyonline.png": 94065,
	"./fancourier-mini.png": 7136,
	"./fancourier.png": 85687,
	"./fastcentrik.png": 69516,
	"./fedex-mini.png": 86089,
	"./fedex.png": 1379,
	"./fhb-mini.png": 1769,
	"./fhb.png": 51390,
	"./fio.png": 41786,
	"./flowii.png": 18128,
	"./foxpost-mini.png": 42790,
	"./foxpost.png": 57465,
	"./freshbooks.png": 33485,
	"./geis-mini.png": 66248,
	"./geis.png": 15784,
	"./gls-mini.png": 65574,
	"./gls.png": 84624,
	"./gomag.png": 3759,
	"./google.svg": 5075,
	"./gopay.png": 45523,
	"./helper.png": 36360,
	"./heureka.png": 20674,
	"./idoklad.png": 31084,
	"./idosell.png": 80768,
	"./ifirma.png": 6888,
	"./ikelp.png": 37969,
	"./ikros.png": 34647,
	"./imap.png": 92131,
	"./infakt.png": 86328,
	"./inpost-mini.png": 75165,
	"./inpost.png": 15317,
	"./inteo.png": 46508,
	"./kaufland-mini.png": 63423,
	"./kaufland.png": 29979,
	"./kodas.png": 49754,
	"./kros.png": 14644,
	"./krosfakturacia.png": 73551,
	"./kurier123-mini.png": 97694,
	"./kurier123.png": 49945,
	"./ladesk.png": 84547,
	"./landing-ai-chatbot.jpg": 73550,
	"./landing-ai-related-products.jpg": 87431,
	"./landing-ai-search.jpg": 41337,
	"./landing-maps.jpg": 73038,
	"./magento.png": 93963,
	"./mall-mini.png": 87267,
	"./mall.png": 33769,
	"./merchantpro.png": 79579,
	"./mksoft.png": 25950,
	"./mollie.png": 28526,
	"./moneta.png": 88709,
	"./money.png": 71295,
	"./moneys3.png": 775,
	"./moneys4.png": 38060,
	"./mpl-mini.png": 12188,
	"./mpl.png": 28165,
	"./mpohoda.png": 7540,
	"./mrp.png": 57101,
	"./mtokna-white.png": 15129,
	"./mtokna.png": 81706,
	"./oberon.png": 51651,
	"./oblio.png": 42832,
	"./omega.png": 49049,
	"./onix.png": 53829,
	"./owicreative.png": 45242,
	"./paletexpress.png": 55772,
	"./paypal.png": 13167,
	"./pdf.png": 71900,
	"./pocztapolska-mini.png": 74044,
	"./pocztapolska.png": 61454,
	"./pohoda.png": 68642,
	"./pohodaorders.png": 98926,
	"./pohodaserver.png": 28205,
	"./poiint-mini.png": 82114,
	"./poiint.png": 83999,
	"./posta-mini.png": 32497,
	"./posta.png": 14005,
	"./ppl-mini.png": 58138,
	"./ppl.png": 214,
	"./prestashop.png": 96371,
	"./profit365.png": 86275,
	"./public.png": 68487,
	"./qdl-mini.png": 94215,
	"./qdl.png": 31251,
	"./rainpro-mini.png": 72770,
	"./rainpro-white.png": 29393,
	"./rainpro.png": 12737,
	"./redcart.png": 30832,
	"./remax-mini.png": 90589,
	"./remax.png": 26114,
	"./royalpets.png": 74778,
	"./sameday-mini.png": 85635,
	"./sameday.png": 2677,
	"./sds-mini.png": 7891,
	"./sds.png": 12562,
	"./selly.png": 28942,
	"./shoper.png": 91224,
	"./shopify.png": 88077,
	"./shoprenter.png": 80353,
	"./shoptet.png": 7066,
	"./skyshop.png": 31479,
	"./slovenskaposta-mini.png": 24310,
	"./slovenskaposta.png": 62975,
	"./slsp.png": 39171,
	"./smartbill.png": 53940,
	"./spajame.png": 8804,
	"./sps-mini.png": 11552,
	"./sps.png": 31033,
	"./stripe.png": 26512,
	"./superfaktura.png": 50292,
	"./szamlazz.png": 52257,
	"./tatrabanka.png": 97961,
	"./toptrans-mini.png": 22188,
	"./toptrans.png": 70394,
	"./turbofaktura.png": 34400,
	"./unas.png": 65398,
	"./upgates.png": 98123,
	"./vub.png": 95677,
	"./vyfakturuj.png": 55033,
	"./webareal-marketplace.png": 61467,
	"./webareal.png": 62676,
	"./webpay.png": 55507,
	"./wfirma.png": 94972,
	"./wix.png": 15348,
	"./woocommerce.png": 71313,
	"./xero.png": 38265,
	"./zasielkovna-mini.png": 74389,
	"./zasielkovna.png": 77947,
	"./zbozi.png": 24433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15702;